export default {"src":"/_next/static/media/Experian.fd589235.svg","height":80,"width":80};